module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-danger"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.register.addNew')))])]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail3"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail3",
      "placeholder": "*"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.register.username')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.register.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "*"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.register.surname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surname),
      expression: "surname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "*"
    },
    domProps: {
      "value": (_vm.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.register.studentId')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentId),
      expression: "studentId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.studentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.studentId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.register.newUserRole')) + " ")]), _vm._v(" "), _vm._l((_vm.roleList), function(role) {
    return _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rolesSelected),
        expression: "rolesSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": role.id,
        "checked": Array.isArray(_vm.rolesSelected) ? _vm._i(_vm.rolesSelected, role.id) > -1 : (_vm.rolesSelected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.rolesSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = role.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.rolesSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.rolesSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.rolesSelected = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(role.displayName) + "\n            ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createUser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.Add))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.createUserMsg))])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00aaeb82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00aaeb82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/CreateUser.vue
// module id = 1405
// module chunks = 1